import script from "./StudentProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudentProfile.vue?vue&type=script&setup=true&lang=ts"

import "./StudentProfile.vue?vue&type=style&index=0&id=0c48f62e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c48f62e"]])

export default __exports__